<template>
  <div class="flex items-center gap-x-2 group cursor-pointer">
    <div class="shrink-0 size-8 group-hover:scale-110 transition-transform relative">
      <img :src="row.Program.iconUrl" class="size-full object-cover rounded-md shadow">
    </div>
    <div class="grow group-hover:brightness-50 truncate flex items-center gap-x-2">
      {{ row.Program.name }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  row: {
    type: Object,
    default: () => {}
  }
});
</script>
